<template>
	<p class="text-2xl font-semibold"><slot/></p>
</template>
<script setup lang="ts"></script>